import React, { useEffect, useState } from "react";
import PropTypes from 'prop-types';
import './style.scss';

import { API } from '../../API';

import { Candidate } from "./Candidate";
import { HeadVoting } from "./HeadVoting";
import { Ended } from "./Ended";
import { Loader } from "../Loader";
import { Modal } from "../Modal";
import { GeneralModal } from "../modals/GeneralModal";
import { ConfirmCandidate } from "../modals/templatesModal/ConfirmCandidate";

const MAX_VOTE = 2;

export const Main = ({ votingData = {}, path, setTimeIsUp }) => {

    const dateNow = Date.now();
    const remainder = votingData.voting.date_finish*1000 - dateNow;

    const timeLeft = remainder <= 0 ? 0 : remainder;
    const isArchive = votingData.voting.status !== 'active';

    //---------------------------
    const [activeVote, setActiveVote] = useState([]);
    const [selectedIdCandidate, setSelectedIdCandidate] = useState(null);
    const [candidatesOrigin, setCandidatesOrigin] = useState({});
    const [candidatesSearch, setCandidatesSearch] = useState([]);
    const [errorConfirmVote, setErrorConfirmVote] = useState(false);

    const usedVote = MAX_VOTE - votingData.metadata.available_voices + activeVote.length;
    const isDoneVoting = usedVote === MAX_VOTE;

    const getAllCandidates = async () => {
        try {
            const allCandidates = await API.get_all_candidates(path);

            if (!allCandidates?.data?.total) {
                setCandidatesOrigin({ total: 0 });
                throw new Error('empty candidates');
            }
            setCandidatesOrigin(allCandidates.data);
            setCandidatesSearch(allCandidates.data.items);

        } catch (e) {
            console.log('error==>', e);
        }
    };

    useEffect(() => {
        // АПИ работы с кандидатами
        getAllCandidates();
    }, []);

    const onSelect = (ind, id, indexOfArr) => {
        if (isDoneVoting) {
            return null;
        }

        setSelectedIdCandidate({ ind, id, indexOfArr });
        //console.log('candidate id', id);

    };

    const onConfirmSelect = async () => {
        if (!selectedIdCandidate) {
            return null;
        }

        try {
            await API.post_candidate_vote(path, selectedIdCandidate.id);
            const activeV = [...activeVote];

            activeV.push(selectedIdCandidate.ind);
            setActiveVote(activeV);
            //console.log('activeV', activeV);
        } catch (e) {
            setErrorConfirmVote(true);
            //console.log('не удалось проголосовать за кандидата');
        }

    };

    const onSearch = (e) => {
        const val = e.target.value.toLowerCase();

        const newCandidate = candidatesOrigin.items.filter((item) => {
            const name = item.candidate.title.toLowerCase();

            return name.indexOf(val) >=0;
        });

        setCandidatesSearch(newCandidate);
    };

    const renderCandidates = () => {

        if (candidatesOrigin.total === undefined) {
            return <Loader />;
        }

        if (candidatesOrigin.total === 0) {
            return (
                <div className = 'candidate__empty'>
                    <span>Кандидатів не додано до голосування</span>
                </div>
            );
        }

        const result =  candidatesSearch.map((item, index) => {
            return (<Candidate
                activeVote = { item.metadata.voted }
                arrActiveId = { activeVote }
                doneVoting = { isArchive || isDoneVoting }
                indexOfArr = { index }
                key = { item.candidate.id }
                person = { item.candidate }
                onSelect = { onSelect }
            />);
        });

        if (!result.length) {
            return (
                <div className = 'candidate__empty'>
                    <span>За вашим запитом кандидатів не знайдено</span>
                </div>
            );
        }

        return result;
    };

    const onCloseModalConfirm = () => {
        setSelectedIdCandidate(null);
        setErrorConfirmVote(false);
    };

    if (!votingData.voting.id) {
        return null;
    }

    /*    console.log('selectedIdCandidate----', selectedIdCandidate);
    console.log('candidatesSearch[selectedIdCandidate.ind-1]----', candidatesSearch[selectedIdCandidate.ind-1]);*/

    return (
        <section className = 'voting'>
            <div className = 'voting__head'>
                {!isArchive &&
                <HeadVoting
                    availableVoices = { usedVote }
                    maxVote = { MAX_VOTE }
                    setTimeIsUp = { setTimeIsUp }
                    timeLeft = { timeLeft }

                    /*voted = {  }*/
                    voted = { activeVote.length > 0 && votingData.metadata.available_voices === MAX_VOTE ? 1 : 0 }
                    voterTotalCount = { votingData.metadata.voter_total_count }
                    voterVotedCount = { votingData.metadata.voter_voted_count }
                />
                }
            </div>
            <div className = 'm-width voting__body-wrap'>
                {
                    isArchive &&
                    <Ended linkDocument = { votingData.voting.link_protocol } />
                }
                <div className = 'voting__body '>

                    <div className = 'voting__information'>
                        <span className = 'voting__text voting__text-about'>Про голосування:</span>
                        <h2 className = 'voting__title'>{votingData.voting.title}</h2>
                        <p className = 'voting__text'>
                            {votingData.voting.description}
                        </p>
                    </div>

                    <div className = 'voting__search-container'>
                        <p className = 'voting__search-text'>Кандидати голосування:</p>
                        <div className = 'voting__search-wrap'>
                            <i className = { ` voting__search-icon icon icon-search` } />
                            <input className = 'voting__search-field' placeholder = 'Пошук кандидата' type = 'text' onChange = { onSearch } />
                        </div>
                    </div>
                    <div className = 'voting__separate' />
                    <div className = 'voting__candidates'>
                        {
                            renderCandidates()
                        }
                    </div>
                </div>
            </div>

            <Modal isModal = { selectedIdCandidate !== null }>
                <GeneralModal onClose = { onCloseModalConfirm }>
                    <ConfirmCandidate
                        data = { candidatesSearch[selectedIdCandidate?.indexOfArr] } //:FIXME -1 это просто для работы
                        errorConfirmVote = { errorConfirmVote }
                        onClose = { onCloseModalConfirm }
                        onConfirm = { onConfirmSelect }
                    />
                </GeneralModal>
            </Modal>

        </section>

    );
};

Main.propTypes = {
    path:        PropTypes.string.isRequired,
    setTimeIsUp: PropTypes.func.isRequired,
    votingData:  PropTypes.object.isRequired,
};
